/* es5-ext/array/from/index */ function _(require, module, exports) {
    module.exports = require(324) /* ./is-implemented */()
        ? Array.from
        : require(325) /* ./shim */;
}
